import { Row } from "@tanstack/react-table";
import { MonthlyGroupDataType } from "../../../../../stores/types/campaignsTypes.tsx";
import { fullFormatNumbers } from "../../../../../helpers/functions/formatNumber.ts";
import { RevInput } from "@revmatics/catalyst";

type Props = {
  row: Row<MonthlyGroupDataType>;
  edit: boolean;
};

export const MediaPlanMonthlySubComponent = ({ row, edit }: Props) => {
  return (
    <table className="divide-x divide-monochrome-100">
      <thead className="bg-primary-505 divide-y divide-monochrome-200">
        <tr key={row.id + "head"}>
          <th className="pl-[54px] py-4 text-start typography-body-bold-sm text-monochrome-900  sticky z-10 left-0">
            Platforms
          </th>
        </tr>
      </thead>
      <tbody className="bg-primary-508 divide-x divide-monochrome-100">
        {row.original.sub_groups?.map((subGroup, subIndex) => (
          <tr key={subGroup.id + "sub-group"}>
            <td
              key={subGroup.id + "sub-group-name"}
              className={`whitespace-nowrap text-sm text-monochrome-900 w-[207px] sticky z-10 left-0`}
            >
              <div className={`h-[66px] grid grid-cols-[52px_1fr]`}>
                <div className={`h-full bg-primary-505`}></div>
                <div
                  className={`${subIndex === 0 ? "border-y" : "border-b"} border-monochrome-100 border-l shadow-elevation-inset-right-100 px-3 py-2 bg-primary-508 flex items-center`}
                >
                  <p className="typography-body-sm text-monochrome-900">
                    {subGroup.name}
                  </p>
                </div>
              </div>
            </td>
            <td
              key={subGroup.id + "sub-group-total"}
              className={`${subIndex === 0 ? "border-y" : "border-b"} px-4 py-3 whitespace-nowrap text-sm text-monochrome-900 border-r border-monochrome-100`}
            >
              <div className="gap-y-0.5 flex flex-col items-end min-w-[118px]">
                <p className="typography-body-sm text-monochrome-900">
                  $
                  {fullFormatNumbers({
                    value: subGroup.total.amount,
                    noFormatNumber: true,
                    shortenValue: 1e3,
                  })}
                </p>
                {edit ? (
                  <RevInput
                    name={`monthly-${subGroup.id}-${subGroup.name}`}
                    type="number"
                    label=""
                    size="sm"
                    afterText="%"
                    defaultValue={subGroup.total.percentage.toFixed(2)}
                    inputClassName="text-end"
                  />
                ) : (
                  <p className="typography-body-xs text-monochrome-500">
                    {subGroup.total.percentage.toFixed(2)}%
                  </p>
                )}
              </div>
            </td>
            {Object.keys(subGroup.months).map((key) => {
              return (
                <td
                  key={subGroup.id + "sub-group-total" + key}
                  className={`${subIndex === 0 ? "border-y" : "border-b"}  border-r border-monochrome-100 px-4 py-3 whitespace-nowrap text-sm text-monochrome-900`}
                >
                  <div className="gap-y-0.5 flex flex-col items-end min-w-[118px]">
                    <p className="typography-body-sm text-monochrome-900">
                      $
                      {fullFormatNumbers({
                        value: subGroup.months[key].amount,
                        noFormatNumber: true,
                        shortenValue: 1e3,
                      })}
                    </p>
                    {edit ? (
                      <RevInput
                        name={`monthly-${subGroup.id}-${subGroup.name}`}
                        type="number"
                        label=""
                        size="sm"
                        afterText="%"
                        defaultValue={subGroup.months[key].percentage.toFixed(
                          2,
                        )}
                        inputClassName="text-end"
                      />
                    ) : (
                      <p className="typography-body-xs text-monochrome-500">
                        {subGroup.months[key].percentage.toFixed(2)}%
                      </p>
                    )}
                  </div>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
